// extracted by mini-css-extract-plugin
export default {"cn_item":"Item_cn_item__ZMvGl","item":"Item_item__aSp8M","item_icon":"Item_item_icon__acOSK","item_content":"Item_item_content__bGDgM"};